export const DATA_POINT_PROXIMITY_THRESHOLD_MS = 10 * 60 * 1000 // 10 minutes
export const POINT_TIME_DIFFERENCE_THRESHOLD_MS = 1000 // 1 second

export const findClosestIndex = (arr, target) => {
  if (!arr?.length) return -1
  if (target <= arr[0]) return 0
  if (target >= arr[arr.length - 1]) return arr.length - 1

  let left = 0
  let right = arr.length - 1

  while (left < right) {
    const mid = Math.floor((left + right) / 2)
    if (arr[mid] === target) return mid
    if (arr[mid] < target) {
      left = mid + 1
    } else {
      right = mid
    }
  }
  return (left > 0 && Math.abs(arr[left] - target) >= Math.abs(arr[left - 1] - target)) ? left - 1 : left
}

export const formatDisplayTimestamp = (timestamp) => {
  const date = new Date(timestamp)
  if (isNaN(date.getTime())) {
    return 'Date/Time N/A'
  }
  const dateOptions = { month: 'short', day: '2-digit', year: 'numeric' }
  const timeOptions = { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true }
  return `${date.toLocaleDateString(undefined, dateOptions)} ${date.toLocaleTimeString(undefined, timeOptions)}`
}

export const formatNumberBySignificantFigures = (number) => {
  if (number === null || typeof number === 'undefined') {
    return 'N/A'
  }

  const absNumber = Math.abs(number)

  if (absNumber >= 100) {
    return number.toFixed(0)
  }
  if (absNumber >= 10) {
    return number.toFixed(1)
  }
  return number.toFixed(2)
}
